import { render } from "./PawpulseServiceSection.vue?vue&type=template&id=862dd91e&scoped=true"
import script from "./PawpulseServiceSection.vue?vue&type=script&lang=js"
export * from "./PawpulseServiceSection.vue?vue&type=script&lang=js"

import "./PawpulseServiceSection.vue?vue&type=style&index=0&id=862dd91e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-862dd91e"],['__file',"PawpulseServiceSection.vue"]])

export default __exports__